

export default function Loader() {
    return (
        <div className="flex flex-col gap-4 h-full w-full items-center justify-center">

            <div className="flex gap-2">

                <span className="size-3 animate-ping rounded-full bg-[var(--footer-background-color)]"></span>

                <span className="size-3 animate-ping rounded-full bg-[var(--footer-background-color)] [animation-delay:0.2s]"></span>

                <span className="size-3 animate-ping rounded-full bg-[var(--footer-background-color)] [animation-delay:0.4s]"></span>

            </div>

        </div>

    );
}